import React from 'react'

import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'
import { Grid, Cell } from 'components/layout/grid'
import DropDown from './DropDown/DropDown'

import s from './CustomSelect.scss'


const CustomSelect = ({
  className, valueLink, placeholder, label, options, onChange,
}) => (
  <div className={className}>
    <Text
      message={label}
      size="16-19"
      color="gray"
    />
    <DropDown
      className={s.dropDown}
      openerClassName={s.opener}
      dropListClassName={s.dropList}
      opener={valueLink.value.node}
    >
      {
        ({ toggleClose }) => (
          <Box p={8}>
            <Grid columns={4}>
              {
                options.map(({ node, value }, index) => (
                  <Cell key={index} size={1}>
                    {
                      React.cloneElement(node, {
                        onClick: () => {
                          toggleClose()
                          valueLink.set({ node, value })
                        },
                      })
                    }
                  </Cell>
                ))
              }
            </Grid>
          </Box>
        )
      }
    </DropDown>
  </div>
)


export default CustomSelect
